/**
 * bd ogc — Pure orchestration helper. When the visible method tile list
 * changes (currency filter, BLOCK risk decision, strategy reload), reconcile
 * the shopper's current selection:
 *   - keep the prior selection if it is still visible
 *   - else fall back to pickDefaultMethod(visible)
 *   - else null (no methods at all → caller must handle "nothing to pay with")
 *
 * Lives at module scope so App.tsx's reactive effect can stay declarative
 * (`setSelectedMethod(prev => reconcileSelectedMethod(prev, visible))`).
 */
import { pickDefaultMethod } from './method-defaults.js';

interface TileLike {
  paymentMethod: string;
}

export function reconcileSelectedMethod<T extends TileLike>(
  prev: string | null,
  visible: T[],
): string | null {
  if (prev && visible.some((m) => m.paymentMethod === prev)) {
    return prev;
  }
  return pickDefaultMethod(visible);
}
